import {Component, OnInit} from '@angular/core';
import { HttpClient } from '@angular/common/http';
import {NgbModal} from '@ng-bootstrap/ng-bootstrap';
import {catchError, finalize, switchMap, tap} from 'rxjs/operators';
import {environment} from '../../../environments/environment';
import {DisplayPipe} from '@shared/pipes/display.pipe';
import {BaseService} from '@shared/services/base.service';
import {ToastService} from '@shared/services/toast.service';
import {ErrorHandlingService} from '@shared/services/error-handling.service';
import {GenericModalComponent} from '@shared/modals/generic-modal/generic-modal.component';
import {FormsModule} from '@angular/forms';
import {DatePipe, NgForOf, NgIf} from '@angular/common';
import {DisplayFieldComponent} from '@shared/display-field/display-field.component';


@Component({
    selector: 'app-beach-results',
    templateUrl: './beach-results.component.html',
    styleUrls: ['./beach-results.component.css'],
    providers: [DisplayPipe],
    imports: [
        FormsModule,
        NgIf,
        NgForOf,
        DisplayFieldComponent,
        DatePipe
    ]
})
export class BeachResultsComponent implements OnInit {
  private monitoringLocationService: BaseService;
  private monitoringActivityService: BaseService;
  private observationResultsService: BaseService;
  private labResultsService: BaseService;
  private criteriaService: BaseService;
  private characteristicService: BaseService;
  public loading = false;
  public saving = false;
  public criteria;
  public items;
  public meta;
  public item;
  public individualID: string;
  public labId: string;
  private results;
  private metaResults;
  // private sampleDate;
  private charResults: any;
  private charMeta: any;
  private geomeanActivities: any[];
  private startDate: string;

  constructor(http: HttpClient, public toastr: ToastService, private displayPipe: DisplayPipe,
              private errorHandling: ErrorHandlingService, private modalService: NgbModal) {
    this.monitoringLocationService = new BaseService(`${environment.baseUrl}/beaches/monitoringlocation`, http);
    this.monitoringActivityService = new BaseService(`${environment.baseUrl}/beaches/monitoringactivity`, http);
    this.observationResultsService = new BaseService(`${environment.baseUrl}/beaches/result`, http);
    this.labResultsService = new BaseService(`${environment.baseUrl}/beaches/labresults`, http);
    this.criteriaService = new BaseService(`${environment.baseUrl}/beaches/criteria`, http);
    this.characteristicService = new BaseService(`${environment.baseUrl}/beaches/characteristicchoices`, http);
  }

  ngOnInit() {
    this.item = {};
    this.criteriaService.getList<any>({}).pipe(tap(criteriaResponse => {
      this.criteria = criteriaResponse.results;
    })).subscribe();

  }

  /*global angular */

  public loadActivities() {
    this.loading = true;
    this.monitoringActivityService.getList<any>({
      page_size: 1000,
      missing_results: true,
      ordering: 'sample_collection_datetime'
    }).pipe(tap(response => {
        // response.results.forEach(location => {
        //   this.items.push({monitoring_location: location.globalid});
        //   this.meta.fields.monitoring_location.choices.push({
        //     display_name: location.name + ' (' + location.id + ')',
        //     value: location.globalid,
        //     id: location.id
        //   });
        // });
        this.meta = response.meta;
        this.items = response.results.map(i => {
          i.characteristicname = 'Enterococcus';
          return i;
        });
        // this.meta.fields.analytical_method_id =  this.charMeta.fields.default_analytical_method_id;
        // this.meta.fields.analytical_method_context = this.charMeta.fields.default_analytical_method_context;
        // this.meta.fields.analytical_method_name = this.charMeta.fields.default_analytical_method_name;
        // this.meta.fields.analytical_method_text = this.charMeta.fields.default_analytical_method_text;
        this.meta.display_fields = ['activityid', 'monitoring_location', 'sample_collection_datetime'];
        this.meta.observations = ['wind', 'windDirection', 'tidalStage', 'waterSurface', 'waterColor', 'turbid',
          'smell', 'weather24Hour', 'weatherNow', 'other', 'averageTemp', 'rainfallWeekly', 'averageHumidity'];
        this.meta.fields.monitoring_location.type = 'choice';
        this.meta.fields.monitoring_location.choices = [];
        for (const key of Object.keys(this.meta.fields)) {
          const field = this.meta.fields[key];
          if (field.default !== undefined) {
            this.item[key] = field.default;
            this.items.forEach(item => {
              item[key] = field.default;
            });
          }
        }
      })
    ).subscribe(() => this.monitoringLocationService.getList<any>({
      page_size: 1000
    }).pipe(tap(locations => {
      console.log(locations.results);
      locations.results.forEach(location => {
        this.meta.fields.monitoring_location.choices.push({
          display_name: location.name + ' (' + location.locationid + ')',
          value: location.globalid,
          id: location.locationid
        });
      });
    }), finalize(() => {

      this.loading = false;
    })).subscribe());

  }

  getLabResults(labId) {
    this.loading = true;
    let sampleDate;
    let results;
    let labMeta;
    this.labResultsService.getList<any>({
      lab_id: labId,
      page_size: 100,
    }).pipe(
      tap(response => {
          sampleDate = new Date(response.results[0].date_collected).toISOString();
          // this.startDate = new Date(response.results[1].created_date).toISOString();
          results = response.results.map(result => {
            result.compare_string = result.field_id.replace(/\s/g, '')
              + result.date_collected.slice(0, 10).replace(/-/g, '');
            return result;
          });
          labMeta = response.meta;
        }
      ),
      switchMap(() => this.monitoringActivityService.getList<any>({
          sample_date: sampleDate,
          page_size: 1000,
          missing_results: true
        })
      ),
      tap(activities => {
        this.meta = activities.meta;
        this.meta.fields.lab_sample_id = labMeta.fields.lab_sample_id;
        this.meta.fields.lab_field_id = labMeta.fields.lab_field_id;
        this.meta.fields.lab_date_collected = labMeta.fields.date_collected;
        this.meta.display_fields = [
          'activityid', 'monitoring_location', 'sample_collection_datetime', 'lab_sample_id'
        ];
        this.meta.fields.monitoring_location.type = 'choice';
        this.meta.fields.monitoring_location.choices = [];
        this.items = activities.results.map(activity => {
          const compareString = activity.activityid.replace(/-0/g, '').replace(/-/g, '');
          const matchResults = results.filter(value => value.compare_string === compareString);
          matchResults.forEach(match => {
            if (match.result === 0) {
              activity.measure = 9;
            } else if (match.result > 24196) {
              activity.measure = 24197;
            } else {
              activity.measure = match.result;
            }
            // todo: setup way to translate lab to wqx analyte names
            activity.characteristicname = match.analyte.indexOf('Enterococci') > -1 ? 'Enterococcus' : match.analyte.replace(/\s{2,}/g, '');
            activity.lab_sample_id = match.lab_sample_id.replace(/\s{2,}/g, '');
            activity.lab_field_id = match.location.replace(/\s{2,}/g, '') + ' (' + match.field_id.replace(/\s{2,}/g, '') + ')';
            activity.lab_date_collected = match.date_collected;
          });
          return activity;
        });
      }),
      switchMap(() => this.monitoringLocationService.getList<any>({page_size: 1000})),
      tap(responseLocate => {
        responseLocate.results.forEach(location => {
          this.meta.fields.monitoring_location.choices.push({
            display_name: location.name + ' (' + location.locationid + ')',
            value: location.globalid,
            id: location.locationid
          });
        });
      }),
      finalize(() => this.loading = false))
      .subscribe();
  }

  calculateGeomean(activity) {
    this.monitoringActivityService.getList<any>({
      page_size: 4,
      missing_results: 'False',
      ordering: '-sample_collection_datetime',
      search: activity.monitoring_location
    }).pipe(tap(response => {
      this.geomeanActivities = response.results;
    })).subscribe(() => {
      this.observationResultsService.getList<any>({
        monitoring_activity: activity.globalid,
        page_size: 4,
        ordering: '-sample_collection_datetime',
      }).pipe(tap(resultsResponse => {
        activity.geomean = Math.pow((resultsResponse.results[0].measure
          * resultsResponse.results[1].measure * resultsResponse.results[2].measure
          * resultsResponse.results[3].measure * activity.measure), 1 / 5);
        const currentCriteria = this.criteria.find(value => value.value === activity.monitoring_location);
        if (currentCriteria.length === 0) {
          const thisCriteria = this.criteria.find(value => value.value.default === true);
        }

        // if (activity.measure > currentCriteria[0].wet_single_criteria
        //   || activity.geomean > currentCriteria[0].wet_geo_criteria) {
        //   activity.advisory = true;
        // } else {
        //   activity.advisory = false;
        // }
      })).subscribe();
    });
  }

  save() {
    this.saving = true;
    const modalInstance = this.modalService.open(GenericModalComponent);
    let hadError = false;
    let result;
    modalInstance.componentInstance.title = 'Please confirm';
    modalInstance.componentInstance.text = 'Are you sure you are ready to save?';
    modalInstance.result.then(() => {
      this.errorHandling.clearError(this.meta);
      this.errorHandling.customErrorMessage = true;
      this.errorHandling.customSaveMessage = true;
      this.items.map(item => {
        if (item.measure !== undefined && item.measure !== null && item.characteristicname !== undefined) {
          // const methodDefaults = this.charResults.find(value => value.value === item.characteristicname);
          const resultSubmit = {
            measure: item.measure,
            // analytical_method_context: methodDefaults.default_analytical_method_context,
            // analytical_method_id: methodDefaults.default_analytical_method_id,
            // analytical_method_name: methodDefaults.default_analytical_method_name,
            // analytical_method_text: methodDefaults.default_analytical_method_text,
            characteristicname: item.characteristicname,
            monitoring_activity: item.globalid,
            valuetype: 'Actual'
          };
          result = this.observationResultsService.post(resultSubmit).pipe(tap(), catchError(error => {
            hadError = true;
            return this.errorHandling.fieldError(error, this.meta);
          })).subscribe(() => {
            if (hadError) {
              hadError = false;
              this.toastr.error('Error');
            } else {
              this.toastr.success('Succesfully saved results');
              this.items = undefined;
            }
            // switch back to false so it doesn't prevent default error message
            this.errorHandling.customErrorMessage = false;
            this.saving = false;
          });
        }
      });
    });
  }

  public getActivities() {
    if (this.items === undefined) {
      this.items = [];
      this.loadActivities();
    } else {
      const modalInstance = this.modalService.open(GenericModalComponent);
      modalInstance.componentInstance.title = 'Please Confirm';
      modalInstance.componentInstance.text = 'By selecting this you will reload all of the activities and any unsaved ' +
        'changes will be lost.';
      modalInstance.result.then(() => {
        // clear and load beaches
        this.items = [];
        this.loadActivities();
      });
    }
  }

  public getResults(labId) {
    if (this.items === undefined) {
      this.items = [];
      this.getLabResults(labId);
    } else {
      const modalInstance = this.modalService.open(GenericModalComponent);
      modalInstance.componentInstance.title = 'Please Confirm';
      modalInstance.componentInstance.text = 'By selecting this you will reload all of the activities and any unsaved ' +
        'changes will be lost.';
      modalInstance.result.then(() => {
        // clear and load beaches
        this.items = [];
        this.getLabResults(labId);
      });
    }
  }

  // .controller('ModalController', ['$scope', '$uibModalInstance',
  //     function ($scope, $uibModalInstance) {
  //         $scope.ok = function () {
  //             $uibModalInstance.close();
  //         };
  //
  //         $scope.cancel = function () {
  //             $uibModalInstance.dismiss('cancel');
  //         }
  //     }]);
}
